// notify-me.js
// Wires up "NOTIFY ME" buttons on sold-out products. Reuses the store's existing
// Omnisend embedded form (already present elsewhere on the page) by moving that
// exact DOM node into the modal on open, and moving it back to its original spot
// on close, so the live Omnisend widget instance is never duplicated or reloaded.
(function () {
  function findEmbed(selector) {
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (err) {
      return null;
    }
  }

  function restoreEmbed(embedNode) {
    if (!embedNode || !embedNode._notifyMeOriginalParent) return;
    embedNode._notifyMeOriginalParent.insertBefore(embedNode, embedNode._notifyMeOriginalNextSibling || null);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.notify-me-button');
    if (!button) return;

    const opener = button.closest('modal-opener');
    const modalSelector = opener && opener.getAttribute('data-modal');
    const modal = modalSelector ? document.querySelector(modalSelector) : null;
    if (!modal) return;

    const embedSelector = button.getAttribute('data-notify-target');
    const embedNode = findEmbed(embedSelector);
    const target = modal.querySelector('.notify-me-modal__embed-target');

    if (embedNode && target && !target.contains(embedNode)) {
      if (!embedNode._notifyMeOriginalParent) {
        embedNode._notifyMeOriginalParent = embedNode.parentNode;
        embedNode._notifyMeOriginalNextSibling = embedNode.nextSibling;
      }
      target.appendChild(embedNode);
    } else if (!embedNode && target && !target.dataset.notifyMeFallback) {
      target.dataset.notifyMeFallback = 'true';
      target.innerHTML =
        '<p class="notify-me-modal__fallback">Enter your email above the buy button on this page to get notified, or check back soon — this drop restocks fast.</p>';
    }
  });

  document.body.addEventListener('modalClosed', function () {
    document.querySelectorAll('.notify-me-modal__embed-target [id^="omnisend-embedded"]').forEach(function (embedNode) {
      restoreEmbed(embedNode);
    });
  });
})();
